
import React from 'react';
import type { LucideProps } from 'lucide-react';

interface QuickActionButtonProps {
  title: string;
  subtitle: string;
  Icon: React.ComponentType<LucideProps>;
  onClick: () => void;
  colorClasses: {
    border: string;
    bg: string;
    iconBg: string;
    iconText: string;
  };
}

const QuickActionButton: React.FC<QuickActionButtonProps> = ({ title, subtitle, Icon, onClick, colorClasses }) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-4 p-4 border-2 border-dashed border-gray-600 rounded-lg ${colorClasses.border} ${colorClasses.bg} transition-all group`}
    >
      <div className={`p-3 bg-gray-700 ${colorClasses.iconBg} rounded-lg transition-colors`}>
        <Icon className={`text-gray-400 ${colorClasses.iconText}`} size={24} />
      </div>
      <div className="text-left">
        <p className="font-semibold text-white">{title}</p>
        <p className="text-sm text-gray-400">{subtitle}</p>
      </div>
    </button>
  );
};

export default QuickActionButton;
